import { useState } from "react";

export interface CommunityUser {
  name: string;
  contact: string;
  method: "email" | "phone";
  whatsapp: string;
  role: string;
  avatar: string; // format: "AB|bg-teal-400"
}

export function useCommunityAuth() {
  const [user, setUser] = useState<CommunityUser | null>(null);

  const login = (u: CommunityUser) => setUser(u);
  const logout = () => setUser(null);

  return { user, login, logout, isLoggedIn: user !== null };
}
